/**
 * Mode ÉMULATEUR local (Firebase Emulator Suite). Activé en posant
 * `VITE_FIREBASE_EMULATORS=1` (cf. .env.local ou la commande dev). Permet de
 * tester l'app — y compris l'admin — SANS toucher la prod ni un vrai compte
 * Google (auth émulée + Firestore/Functions locaux).
 *
 * Ports (alignés sur firebase.json → emulators) : auth 9099, functions 5001,
 * firestore 8080, storage 9199. JAMAIS actif en build de prod (flag absent).
 */

export const EMULATOR_HOST = '127.0.0.1';
export const EMULATOR_PORTS = { auth: 9099, functions: 5001, firestore: 8080, storage: 9199 } as const;

export function emulatorsEnabled(): boolean {
  return import.meta.env['VITE_FIREBASE_EMULATORS'] === '1';
}
